import { useEffect, useState } from 'react'
import SetupMFAStep from '../../components/SetupMFAStep'
import { QRCodeSVG as QRCode } from 'qrcode.react'
import { AuthenticatorAppDownload } from './AuthenticatorAppDownload'
import {
  FINISH,
  NEXT,
  SETUP_MFA_TOTP_FOOTNOTE,
  SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP,
  SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP,
  SETUP_MFA_TOTP_TITLE,
  SETUP_MFA_TOTP_VERIFICATION_CODE,
  SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER,
} from '../../constants/ui.labels'
import Box from '@talkdesk/cobalt-react-box'
import Label from '@talkdesk/cobalt-react-label'
import Input from '@talkdesk/cobalt-react-input'
import InputGroup from '@talkdesk/cobalt-react-input-group'
import Flex from '@talkdesk/cobalt-react-flex'
import Card from '@talkdesk/cobalt-react-card'

const SetupTOTPStep = ({ learnMoreAboutAuthenticatorAppUrl, ...props }) => (
  <SetupMFAStep
    title={SETUP_MFA_TOTP_TITLE}
    footnoteLabel={SETUP_MFA_TOTP_FOOTNOTE}
    footnoteUrl={learnMoreAboutAuthenticatorAppUrl}
    {...props}
  >
    {props.children}
  </SetupMFAStep>
)

export const StartRegistrationStep = ({
  onPrepareRegistration,
  googlePlayBadgeUrl,
  appleStoreBadgeUrl,
  ...otherProps
}) => (
  <SetupTOTPStep
    subtitle={SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP}
    boxContent={
      <AuthenticatorAppDownload
        googlePlayBadgeUrl={googlePlayBadgeUrl}
        appleStoreBadgeUrl={appleStoreBadgeUrl}
      />
    }
    buttonLabel={NEXT}
    buttonAction={onPrepareRegistration}
    {...otherProps}
  />
)

export const RegisterStep = ({
  onFinishRegistration,
  registrationData,
  isProcessing,
  ...otherProps
}) => {
  const [otp, setOtp] = useState('')

  /* eslint-disable react-hooks/set-state-in-effect, @eslint-react/set-state-in-effect */
  useEffect(() => {
    if (!isProcessing) {
      setOtp('')
    }
  }, [isProcessing])
  /* eslint-enable react-hooks/set-state-in-effect, @eslint-react/set-state-in-effect */

  const finishRegistration = () => {
    onFinishRegistration({
      registrationToken: registrationData.token,
      otp,
    })
  }

  const handleOTPChange = (event) => setOtp(event.target.value)

  return (
    <SetupTOTPStep
      subtitle={SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP}
      boxContent={
        <Card outlined>
          <Box paddingX='5' paddingY='2' width='100%'>
            <Flex alignX='center' alignY='center'>
              <QRCode value={registrationData.uri} />
            </Flex>
          </Box>
        </Card>
      }
      buttonLabel={FINISH}
      buttonAction={finishRegistration}
      buttonDisabled={!otp}
      isProcessing={isProcessing}
      {...otherProps}
    >
      <Box paddingTop='2' paddingBottom='5'>
        <Flex direction='column' gap='2'>
          <Box paddingY='2'>
            <Label>{SETUP_MFA_TOTP_VERIFICATION_CODE}</Label>
          </Box>
          <InputGroup disabled={isProcessing}>
            <Input
              type='number'
              value={otp}
              onChange={handleOTPChange}
              placeholder={SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER}
              autoFocus
            />
          </InputGroup>
        </Flex>
      </Box>
    </SetupTOTPStep>
  )
}
